module.exports = function preparePostInitFunction(options, instead) {

  function selectboxReplacement(context) {
    if (!Modernizr.touchevents) {

      context.find('select').each(function(){
        //Označovanie vybraného prvku v selectu robilo problémy
        //Vyberiem hodnotu označeného optionu (s atribútom selected)
        var selectedValue = $(this).find('option[selected="selected"]').val();
        var sel = new Select({
            el: this,
            alignToHighlighted: 'always'
        });

        //Zmením hodnotu nového selectu podľa predtým uloženej
        if(selectedValue)
          sel.change(selectedValue);
      });

      //Natvrdo intervalu označím prvý option. Označoval sa tretí
      var int_option = $('#search_interval option[selected="selected"]');
      if(int_option)
        int_option.attr("selected",true);
    }
    else {
      context.find('select').each(function(){
        $(this).selectTouch();
      });
    }
  }

  function sharedFunction(context) {
    selectboxReplacement(context);
  }
  
  window.airSelectPostRenderFunction = function() {
    selectboxReplacement($('#air-select-block'));
  }
  
  // postInitHook funkce pro letenky
  function letenky (component, context) {

    sharedFunction(context);
  }


  // sestaveni objektu s postInitFunkci
  var postInit = {
    letenky: {
      postInitHook: letenky
    }
  };

  Object.keys(options).forEach((key) => {
    if (instead.length !== 0) {
      if (jQuery.inArray(key, instead) !== 0)
        options[key] = $.extend({}, options[key], postInit[key]);
    } else {
      options[key] = $.extend({}, options[key], postInit[key]);
    }
  });

  return options;

};